<template>
  <v-dialog v-model="open" persistent max-width="500px">
    <v-card>
      <v-card-title>
        <span>{{ $T('page.member.invite.method.community.title') }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-container grid-list-lg text-xs-left>
        <v-layout column wrap>
          <v-flex>
            <select-community
              v-model="inviteTo"
              ref="inviteTo"
              :label="$T('attributes.invite_to')"
              fieldName="invite_to"
            />
          </v-flex>
          <v-flex>
            <select-community
              v-model="inviteFrom"
              ref="inviteFrom"
              :label="$T('attributes.invite_from')"
              fieldName="invite_from"
            />
          </v-flex>
          <v-flex>
            <select-groups-members
              v-model="inviteTargets"
              :communityId="inviteFrom"
              :allowAllCommunity="false"
              :includeGroups="false"
              :excludeSelf="true"
              excludeGuest
              memberSubContent="role"
              ref="inviteTargets"
              :label="$T('attributes.invite_target')"
              :max="50"
              :autofocus="true"
              fieldName="invite_target"
            />
          </v-flex>
          <v-flex>
            <div class="c-flex-container">
              <div class="l">
                <v-select
                  data-vv-name="expire"
                  :items="expireItems()"
                  ref="'input_expire'"
                  :label="$T('attributes.expire')"
                  v-model="expire"
                  color="clr-primary"
                  v-validate="'required'"
                  :error-messages="getMessage('expire')"
                  required
                  :disabled="loading"
                ></v-select>
              </div>
              <div class="r">
                <v-select
                  data-vv-name="expireUnit"
                  :items="expireUnits()"
                  item-text="t"
                  item-value="v"
                  ref="'input_expire_unit'"
                  v-model="expireUnit"
                  color="clr-primary"
                  v-validate="'required'"
                  :error-messages="getMessage('expireUnit')"
                  required
                  :disabled="loading"
                ></v-select>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="clr-btn-cancel" flat @click.native="closeDialog" :disabled="loading">{{ $T('button.close') }}</v-btn>
        <v-btn color="clr-btn" flat @click.native="createNew" :disabled="!savable" :loading="loading">{{
          $T('page.member.invite.create.button')
        }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { invitable, getCommunityMembers, inviteFromCommunity } from '../../api/communityMember';

export default {
  data() {
    return {
      inviteTo: null,
      inviteFrom: null,
      inviteTargets: [],
      expire: null,
      expireUnit: null,
      invitable: false,
      open: false,
      loading: false,
      apiErrors: {},
    };
  },
  watch: {
    inviteTo(newValue, oldValue) {
      if (!newValue || newValue <= 0) {
        this.invitable = false;
        return;
      }
      if (this.inviteFrom == newValue) {
        this.$refs.inviteFrom.addError(newValue, $T('page.member.invite.same.community'));
      } else {
        this.$refs.inviteFrom.clearError();
      }
      this.loading = true;
      this.invitable = false;
      var _this = this;
      invitable(newValue)
        .then(function(response) {
          _this.invitable = response == 1 || response == 2;
          if (!_this.invitable) {
            _this.$refs.inviteTo.addError(newValue, $T('page.member.invite.noauth'));
          }
          _this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          _this.loading = false;
        });
    },
    inviteFrom(newValue, oldValue) {
      if (!newValue || newValue <= 0) return;

      console.log('check' + newValue + ' and ' + this.inviteTo);
      if (this.inviteTo == newValue) {
        this.$refs.inviteFrom.addError(newValue, $T('page.member.invite.same.community'));
      } else {
        this.$refs.inviteFrom.clearError();
      }
    },
  },
  computed: {
    isFormInValid() {
      return Object.keys(this.fields).some(key => this.fields[key].invalid);
    },
    savable() {
      if (this.isFormInValid || this.loading) return false;
      return (
        this.$refs &&
        this.$refs.inviteTo &&
        this.$refs.inviteTo.savable &&
        this.$refs.inviteFrom &&
        this.$refs.inviteFrom.savable &&
        this.$refs.inviteTargets &&
        this.$refs.inviteTargets.savable
      );
    },
  },
  methods: {
    createNew() {
      var communityId = this.inviteTo;

      this.loading = true;
      var _this = this;
      this.$validator.validateAll().then(result => {
        _this.$refs.inviteTo.validate(result => {
          if (!result) {
            console.warn('inviteTo is invalid.');
            return;
          }
          _this.$refs.inviteFrom.validate(result => {
            if (!result) {
              console.warn('inviteFrom is invalid.');
              return;
            }
            _this.$refs.inviteTargets.validate(result => {
              if (!result) {
                console.warn('inviteTargets is invalid.');
                return;
              }
              var data = new FormData();
              data.append('invite_to', _this.inviteTo);
              data.append('invite_from', _this.inviteFrom);
              data.append('invite_target', _this.inviteTargets);
              data.append('expire', _this.expire);
              data.append('expireUnit', _this.expireUnit);

              inviteFromCommunity(data)
                .then(function(response) {
                  _this.$emit('invited', 'community', communityId, data);
                  _this.loading = false;
                  _this.shortMsg($T('page.member.invite.from_com.sent'));
                  _this.closeDialog();
                })
                .catch(function(error) {
                  console.log(error);
                  _this.$refs.inviteTo.addError(communityId, $T('common.failed.register'));
                  _this.loading = false;
                });
            });
          });
        });
      });
    },
    openDialog(expire, expireUnit, communityId) {
      this.$refs.inviteFrom.clearError();
      this.$refs.inviteTo.clearError();
      this.$refs.inviteTargets.clearError();
      this.expire = expire;
      this.expireUnit = expireUnit;
      this.inviteTo = communityId;
      this.inviteFrom = null;
      this.open = true;
      if (!this.fields) this.fields = {};
      if (!this.fields.expire) this.fields.expire = {};
      if (!this.fields.expireUnit) this.fields.expireUnit = {};
      this.fields.expire.invalid = false;
      this.fields.expireUnit.invalid = false;
      setTimeout(this.initFocus, 500);
    },
    initFocus() {
      if (!this.inviteTo) {
        this.$refs.inviteTo.focus();
        return;
      }
      if (!this.inviteFrom) {
        this.$refs.inviteFrom.focus();
        return;
      }
    },
    closeDialog() {
      this.open = false;
    },
    expireItems() {
      var vs = [];
      for (var i = 1; i <= 100; i++) {
        vs.push(i);
      }
      return vs;
    },
    expireUnits() {
      return [
        { v: 'm', t: $T('common.unit.min') },
        { v: 'h', t: $T('common.unit.hour') },
        { v: 'd', t: $T('common.unit.day') },
        { v: 'y', t: $T('common.unit.year') },
      ];
    },
    getMessage(fieldName) {
      return this.apiErrors[fieldName] && this.apiErrors[fieldName][this.inputValue]
        ? this.apiErrors[fieldName][this.inputValue]
        : this.errors.collect(fieldName);
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0px 24px 12px 24px;
}
.c-flex-container {
  display: flex;
  width: 250px;
}
.c-flex-container .l {
  width: 150px;
}
.c-flex-container .r {
  width: 90px;
  padding-left: 10px;
}
</style>
